import { render } from "./interested.vue?vue&type=template&id=05990171"
import script from "./interested.vue?vue&type=script&lang=js"
export * from "./interested.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aun/Development/kmcc/kmcc-cms-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__